// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poll-msg[data-v-558ce50f] {
  max-width: 400px;
  padding: 0 0.3em;
}
.poll-msg .poll-msg-question[data-v-558ce50f] {
  font-weight: bold;
  margin-bottom: 10px;
  word-wrap: break-word;
}
.poll-msg .poll-msg-answer[data-v-558ce50f] {
  cursor: pointer;
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-right: 6px;
}
.poll-msg .poll-msg-answer .poll-answer-left-section[data-v-558ce50f] {
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 14px;
}
.poll-msg .poll-msg-answer .poll-answer-left-section .poll-radio-button[data-v-558ce50f] {
  display: inline-block;
  height: 14px;
  width: 14px;
  border: 2px solid #83c1ef;
  border-radius: 7px;
  margin-left: 1px;
}
.poll-msg .poll-msg-answer .poll-answer-left-section .poll-answer-value[data-v-558ce50f] {
  display: flex;
  align-items: flex-start;
}
.poll-msg .poll-msg-answer .poll-answer-left-section .poll-value[data-v-558ce50f] {
  font-size: 11px;
  font-weight: bold;
  text-align: right;
  min-width: 46px;
}
.poll-msg .poll-msg-answer .poll-answer-left-section .poll-checked[data-v-558ce50f] {
  position: absolute;
  color: #83c1ef;
  width: 18px;
  margin-right: 2px;
  bottom: 2px;
}
.poll-msg .poll-msg-answer .pol-answer-text[data-v-558ce50f] {
  position: relative;
  white-space: normal;
  flex-grow: 1;
  word-break: break-word;
  margin-left: 10px;
}
.poll-msg .poll-msg-answer .poll-votes[data-v-558ce50f] {
  height: 4px;
  width: 100%;
  background-color: #83c1ef;
  position: absolute;
  bottom: -5px;
  border-radius: 2px;
  opacity: 1;
  -webkit-transition: 0.8s;
  -moz-transition: 0.8s;
  -ms-transition: 0.8s;
  -o-transition: 0.8s;
  transition: 0.8s;
}
.poll-msg .poll-votes-all[data-v-558ce50f] {
  font-size: 12px;
  text-align: left;
  color: var(--message-grey-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chatPollMessage.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC","sourcesContent":[".poll-msg[data-v-558ce50f] {\n  max-width: 400px;\n  padding: 0 0.3em;\n}\n.poll-msg .poll-msg-question[data-v-558ce50f] {\n  font-weight: bold;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n}\n.poll-msg .poll-msg-answer[data-v-558ce50f] {\n  cursor: pointer;\n  display: flex;\n  margin-bottom: 10px;\n  position: relative;\n  padding-right: 6px;\n}\n.poll-msg .poll-msg-answer .poll-answer-left-section[data-v-558ce50f] {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  min-width: 14px;\n}\n.poll-msg .poll-msg-answer .poll-answer-left-section .poll-radio-button[data-v-558ce50f] {\n  display: inline-block;\n  height: 14px;\n  width: 14px;\n  border: 2px solid #83c1ef;\n  border-radius: 7px;\n  margin-left: 1px;\n}\n.poll-msg .poll-msg-answer .poll-answer-left-section .poll-answer-value[data-v-558ce50f] {\n  display: flex;\n  align-items: flex-start;\n}\n.poll-msg .poll-msg-answer .poll-answer-left-section .poll-value[data-v-558ce50f] {\n  font-size: 11px;\n  font-weight: bold;\n  text-align: right;\n  min-width: 46px;\n}\n.poll-msg .poll-msg-answer .poll-answer-left-section .poll-checked[data-v-558ce50f] {\n  position: absolute;\n  color: #83c1ef;\n  width: 18px;\n  margin-right: 2px;\n  bottom: 2px;\n}\n.poll-msg .poll-msg-answer .pol-answer-text[data-v-558ce50f] {\n  position: relative;\n  white-space: normal;\n  flex-grow: 1;\n  word-break: break-word;\n  margin-left: 10px;\n}\n.poll-msg .poll-msg-answer .poll-votes[data-v-558ce50f] {\n  height: 4px;\n  width: 100%;\n  background-color: #83c1ef;\n  position: absolute;\n  bottom: -5px;\n  border-radius: 2px;\n  opacity: 1;\n  -webkit-transition: 0.8s;\n  -moz-transition: 0.8s;\n  -ms-transition: 0.8s;\n  -o-transition: 0.8s;\n  transition: 0.8s;\n}\n.poll-msg .poll-votes-all[data-v-558ce50f] {\n  font-size: 12px;\n  text-align: left;\n  color: var(--message-grey-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
